module.exports = __webpack_public_path__ + "static/media/SkillsPage.945e5f01.png";